import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpsertRecurringFeeMutationVariables = Types.Exact<{
  email: Types.Scalars["String"];
  payload: Types.UpsertRecurringFeeInput;
}>;

export type UpsertRecurringFeeMutation = {
  __typename?: "Mutation";
  upsertRecurringFee: {
    __typename?: "RecurringFee";
    id: string;
    serviceName: Types.TaxServiceName;
    customLabel?: string | null;
    customDescription?: string | null;
    amountInCents: number;
    rhythmInMonths: number;
    billingDay: number;
    anchorMonth: number;
    validFrom: string;
    validUntil?: string | null;
    includeInExport: boolean;
    billedThroughMonth?: string | null;
    hasGeneratedRows: boolean;
    updatedAt: string;
  };
};

export const UpsertRecurringFeeDocument = gql`
  mutation upsertRecurringFee(
    $email: String!
    $payload: UpsertRecurringFeeInput!
  ) {
    upsertRecurringFee(email: $email, payload: $payload) {
      id
      serviceName
      customLabel
      customDescription
      amountInCents
      rhythmInMonths
      billingDay
      anchorMonth
      validFrom
      validUntil
      includeInExport
      billedThroughMonth
      hasGeneratedRows
      updatedAt
    }
  }
`;
export type UpsertRecurringFeeMutationFn = Apollo.MutationFunction<
  UpsertRecurringFeeMutation,
  UpsertRecurringFeeMutationVariables
>;

/**
 * __useUpsertRecurringFeeMutation__
 *
 * To run a mutation, you first call `useUpsertRecurringFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRecurringFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRecurringFeeMutation, { data, loading, error }] = useUpsertRecurringFeeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpsertRecurringFeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertRecurringFeeMutation,
    UpsertRecurringFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertRecurringFeeMutation,
    UpsertRecurringFeeMutationVariables
  >(UpsertRecurringFeeDocument, options);
}
export type UpsertRecurringFeeMutationHookResult = ReturnType<
  typeof useUpsertRecurringFeeMutation
>;
export type UpsertRecurringFeeMutationResult =
  Apollo.MutationResult<UpsertRecurringFeeMutation>;
export type UpsertRecurringFeeMutationOptions = Apollo.BaseMutationOptions<
  UpsertRecurringFeeMutation,
  UpsertRecurringFeeMutationVariables
>;
